import React from "react";

export default function ConfirmPopup4({ closeToast, onBackToLoginClick }) {
  const handleClose = () => {
    closeToast(); // Close the toast when "OK" is clicked
    // Call the callback function to navigate
    if (onBackToLoginClick) {
      onBackToLoginClick();
    }
  };

  return (
    <div>
      <div className="">
        <div id="">
          <div id="">
            <p className="popUpText">
              Your password has been reset! Please check your email
            </p>
            <button className="alert_button" onClick={handleClose}>
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
